var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnGameType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 89",
    cx: 24,
    cy: 24,
    r: 24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 173",
    d: "M184.1 220.117a.705.705 0 0 1-.125.177 8.593 8.593 0 0 1-2 1.148 1.162 1.162 0 0 1-.244.04 2.126 2.126 0 0 0-.194-.2 4.771 4.771 0 0 0-3.846-.961 4.287 4.287 0 0 0-2.4 1.21l-2.117-1.181-.2-.181.108-.967a1.945 1.945 0 0 1 .226.036 8.507 8.507 0 0 0 3.508.365 12.887 12.887 0 0 0 1.949-.378 8.573 8.573 0 0 0 3.944-2.535 8.787 8.787 0 0 0 1.953-3.6 7.909 7.909 0 0 0 .262-2.695c.249.243.485.5.749.725a4.149 4.149 0 0 0 1.657.879l.115.491v1.729l-.116.439a4.384 4.384 0 0 0-2.121 1.309 4.685 4.685 0 0 0-1.2 2.494 3.489 3.489 0 0 0 .1 1.659",
    transform: "translate(-148.935 -185.428)",
    style: {
      fill: "#24ae5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 174",
    d: "M139.49 138.488a7.91 7.91 0 0 1-.262 2.695 8.788 8.788 0 0 1-1.953 3.6 8.574 8.574 0 0 1-3.944 2.535 12.885 12.885 0 0 1-1.949.378 8.507 8.507 0 0 1-3.508-.365 1.955 1.955 0 0 0-.226-.036 4.36 4.36 0 0 0-.875-2.836 4.254 4.254 0 0 0-2.468-1.694l-.109-.464a.118.118 0 0 0-.012-.044l.014-1.427a3.293 3.293 0 0 0 .043-.343.449.449 0 0 1 .341-.476 4.636 4.636 0 0 0 2.551-2.2 4.955 4.955 0 0 0 .432-3.242l.074-.143.05-.006.058-.051c.108-.067.212-.141.325-.2.6-.313 1.206-.622 1.81-.932a7.9 7.9 0 0 0 .7.547 4.572 4.572 0 0 0 3.447.633 4.431 4.431 0 0 0 2.266-1.152 1.073 1.073 0 0 1 .291.059c.506.264 1.006.539 1.509.81l.057.079v-.007l.4.722c-.017.167-.047.333-.05.5a4.605 4.605 0 0 0 .42 2.06c.16.342.371.66.559.989m-10.359 6.065a1.239 1.239 0 0 0 .123.187 5.055 5.055 0 0 0 4.813 1.638 5.051 5.051 0 0 0 3.912-6.49 4.61 4.61 0 0 0-1.741-2.444 4.783 4.783 0 0 0-2.6-1.023 5.1 5.1 0 0 0-5.382 3.43 4.882 4.882 0 0 0 .879 4.7",
    transform: "translate(-103.508 -113.524)",
    style: {
      fill: "#4fba6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 175",
    d: "M213.422 124.817a4.431 4.431 0 0 1-2.266 1.152 4.572 4.572 0 0 1-3.447-.633 7.906 7.906 0 0 1-.7-.547l.5-.241 1.1-.22a7.535 7.535 0 0 1 2.574-.081c.672.1 1.333.269 2 .418a.92.92 0 0 1 .249.152",
    transform: "translate(-180.63 -105.066)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 176",
    d: "M333.365 157.492c-.188-.329-.4-.648-.559-.989a4.6 4.6 0 0 1-.42-2.06c0-.167.032-.333.05-.5l.108-.307a5 5 0 0 1 .623.454 8.881 8.881 0 0 1 2.608 4.91.471.471 0 0 1 0 .1 4.147 4.147 0 0 1-1.657-.879c-.264-.225-.5-.482-.749-.725",
    transform: "translate(-297.383 -132.527)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 177",
    d: "M332.638 278.609a3.489 3.489 0 0 1-.1-1.659 4.684 4.684 0 0 1 1.2-2.494 4.383 4.383 0 0 1 2.121-1.309c-.182.662-.319 1.342-.558 1.984a7.5 7.5 0 0 1-1.67 2.612c-.259.267-.526.526-.8.781a.641.641 0 0 1-.2.084",
    transform: "translate(-297.477 -243.92)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 178",
    d: "M206.624 356.788a4.287 4.287 0 0 1 2.4-1.21 4.771 4.771 0 0 1 3.846.961 2.125 2.125 0 0 1 .194.2c-.373.134-.739.3-1.121.4a8.219 8.219 0 0 1-2.8.206 18.581 18.581 0 0 1-2-.391l-.517-.163",
    transform: "translate(-180.274 -320.685)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 179",
    d: "M175.362 33.8c.754-.005 1.508-.017 2.262-.012a.387.387 0 0 1 .407.425q.011.877 0 1.753a.475.475 0 0 1-.518.471c-.291.007-.583 0-.875 0-.075 0-.15 0-.225-.006l-1.037-.046-.015-2.588",
    transform: "translate(-151.164 -20.823)",
    style: {
      fill: "#0d90db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 180",
    d: "m159.854 72.079 1.037.046c.075 0 .15 0 .225.006a.769.769 0 0 1 .24.7q-.017.67 0 1.341a.543.543 0 0 1-.29.539 1.1 1.1 0 0 1-.236.057c-.325.006-.651 0-.976 0H158.7v-2.644l1.162-.05",
    transform: "translate(-135.641 -56.513)",
    style: {
      fill: "#0d90db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 181",
    d: "M0 227.6v1.625a.461.461 0 0 0 .517.522c.291.007.583 0 .874 0h.061a.082.082 0 0 0 .042-.006h1.177v-2.638l-1.243-.048c-.312.016-.623.036-.935.045-.354.01-.5.146-.5.495",
    transform: "translate(12.133 -200.964)",
    style: {
      fill: "#ffc433"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 182",
    d: "M2.671 152.554q0-1.294.007-2.588c-.334 0-.669 0-1-.01a1.721 1.721 0 0 1-.271-.049c-.3.017-.6.042-.906.049-.363.009-.489.123-.491.484v1.571c0 .413.131.535.553.543.294.006.588.029.882.045a.36.36 0 0 0-.257.39v1.77a.36.36 0 0 0 .257.39l1.243.048H3.82v-2.6l-1.15-.045",
    transform: "translate(12.128 -129.052)",
    style: {
      fill: "#ffc433"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 183",
    d: "M55.442 36.445q0-1.3.005-2.6h2.362v2.594a1.748 1.748 0 0 1-.264.049c-.3.01-.6.012-.906.016a1.227 1.227 0 0 0-.257-.062c-.312-.008-.625 0-.937 0",
    transform: "translate(-39.495 -20.879)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 184",
    d: "m55.439 347.058-.008-2.6 1.2-.006 1.167.006v2.593h-2.36",
    transform: "translate(-39.484 -310.384)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 185",
    d: "m143.754 36.487-1.162.05a1.762 1.762 0 0 0-.271-.048c-.306-.007-.612 0-.918-.005q0-1.3.006-2.591l2.331.006.015 2.588",
    transform: "translate(-119.54 -20.92)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 186",
    d: "M175.492 110.917h.976a1.1 1.1 0 0 0 .236-.057c.345.02.691.025 1.033.068a.72.72 0 0 1 .348.193c.05.044.051.154.054.235.009.261.008.523.011.784l-.5.241c-.6.31-1.208.619-1.81.932-.112.058-.217.133-.325.2a.05.05 0 0 0-.034-.01q0-1.292.007-2.585",
    transform: "translate(-151.278 -92.658)",
    style: {
      fill: "#0d90db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 187",
    d: "M175.35 358.694v-1.472a2.329 2.329 0 0 1 .033-.272l2.117 1.181.517.163a.393.393 0 0 1-.419.411c-.75 0-1.5-.006-2.25-.011",
    transform: "translate(-151.152 -322.028)",
    style: {
      fill: "#e64d3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 188",
    d: "m327.766 147.933-.108.307-.4-.722.511.416",
    transform: "translate(-292.606 -126.825)",
    style: {
      fill: "#4fba6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 189",
    d: "m326.477 146.527-.057-.079.057.079",
    transform: "translate(-291.828 -125.829)",
    style: {
      fill: "#5ea5ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 190",
    d: "M180.6 187.758a4.882 4.882 0 0 1-.879-4.7 5.1 5.1 0 0 1 5.382-3.43 4.783 4.783 0 0 1 2.6 1.023c.14.287.283.572.421.86a4.548 4.548 0 0 1 .271 3.279 4.921 4.921 0 0 1-3.644 3.608 4.869 4.869 0 0 1-3.4-.292l-.758-.346",
    transform: "translate(-154.975 -156.729)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 191",
    d: "m196.076 202.133.758.346a4.869 4.869 0 0 0 3.4.292 4.921 4.921 0 0 0 3.644-3.608 4.548 4.548 0 0 0-.271-3.279c-.138-.288-.28-.574-.421-.86a4.61 4.61 0 0 1 1.741 2.444 5.051 5.051 0 0 1-3.912 6.49 5.055 5.055 0 0 1-4.813-1.638 1.237 1.237 0 0 1-.123-.187",
    transform: "translate(-170.453 -171.104)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 192",
    d: "M127.681 150.072a4.955 4.955 0 0 1-.432 3.242 4.636 4.636 0 0 1-2.551 2.2.449.449 0 0 0-.341.476 3.268 3.268 0 0 1-.044.343v-1.162c.126.008.189-.026.216-.173a4.064 4.064 0 0 1 .222-.8c.216-.529.461-1.047.694-1.57l-.007-.1-1.128-.015v-2.588c.177 0 .355.006.531 0 .214-.011.428-.034.642-.052h.281c.3.013.606.028.909.043l-.074 1.059 1.081-.9",
    transform: "translate(-103.623 -129.019)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 193",
    d: "m142.588 114.355-.909-.043h-.281v-2.588h2.351q0 1.292-.007 2.585l-.023.06-.05.006-1.081-.012",
    transform: "translate(-119.536 -93.457)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 194",
    d: "m157.7 150.548 1.081.012-.074.143-1.081.9.074-1.059",
    transform: "translate(-134.651 -129.65)",
    style: {
      fill: "#ffc433"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 195",
    d: "m175.145 149.815.023-.06a.05.05 0 0 1 .034.009l-.058.051",
    transform: "translate(-150.962 -128.911)",
    style: {
      fill: "#7b98c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 196",
    d: "m124.2 74.676.015-2.545.041-.042c.288 0 .576 0 .863-.011a1.627 1.627 0 0 0 .264-.051c.306 0 .612 0 .918.005a1.753 1.753 0 0 1 .271.048v2.644h-1.192l-1.128-.011-.037-.045h-.019",
    transform: "translate(-103.52 -56.465)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 197",
    d: "m124.326 72.836-.041.042-.01-.05.051.007",
    transform: "translate(-103.592 -57.212)",
    style: {
      fill: "#d3eefa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 198",
    d: "m127.759 279.074-.2-.181.107-.967a4.36 4.36 0 0 0-.875-2.835 4.254 4.254 0 0 0-2.468-1.694l.564 2.2h-.628l-.037.039-.017 2.546h.021a.077.077 0 0 0-.008.044h.021l.021-.005-.034-.041.034.041 1.129.013q0 1.3.005 2.591l2.33-.006v-1.472a2.327 2.327 0 0 1 .033-.272",
    transform: "translate(-103.526 -244.152)",
    style: {
      fill: "#f4fbff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 199",
    d: "M41.266 304.945v2.634l-1.2.006h-1.132v-2.646l1.136-.046a1.4 1.4 0 0 0 .238.046c.32.007.641.007.961.009",
    transform: "translate(-24.12 -273.505)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 200",
    d: "M3.819 271.87H2.687v-2.646l1.136-.046v-2.594l-1.136-.009H1.51a.084.084 0 0 1-.042.006l-.059.038a.429.429 0 0 0-.221.421c.007.558-.01 1.116.01 1.673a1.608 1.608 0 0 0 .164.458c-.3.017-.6.04-.9.051s-.441.149-.442.43v1.7a.479.479 0 0 0 .538.517h.8a1.4 1.4 0 0 0-.152.414 37.47 37.47 0 0 0 0 1.774.379.379 0 0 0 .41.411h2.233l-.008-2.595",
    transform: "translate(12.128 -237.79)",
    style: {
      fill: "#e64d3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 201",
    d: "M41.23 227.738v2.632l-1.2.009-1.13-.009v-2.638h1.132l1.2.008",
    transform: "translate(-24.088 -201.588)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 202",
    d: "M22.811 266.572h-1.077 1.077",
    transform: "translate(-8.106 -237.79)",
    style: {
      fill: "#fde5a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 203",
    d: "M41.054 72.12q0 1.312.006 2.625l-1.2.006-1.127-.005-.022-.051.014-2.592 1.137-.048h.937a1.229 1.229 0 0 1 .257.061",
    transform: "translate(-23.912 -56.49)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 204",
    d: "m3.815 39.037-1.127-.005-.022-.051.014-2.591 1.137-.048q0-1.3.005-2.6c-.729 0-1.457-.009-2.186-.007-.318 0-.456.147-.458.471 0 .559-.013 1.118.007 1.676a1.579 1.579 0 0 0 .166.455c-.3.017-.6.041-.9.05s-.442.135-.443.444v1.676a.479.479 0 0 0 .537.527h.8a2.129 2.129 0 0 0-.153.511c-.021.49 0 .982-.011 1.473a.677.677 0 0 0 .228.607 1.726 1.726 0 0 0 .271.049c.334.008.669.008 1 .01.305 0 .611 0 .917-.01a1.366 1.366 0 0 0 .236-.047l-.013-2.6m-2.468 0h.053c.169-.012.339-.026.508-.036-.169.011-.339.025-.508.037h-.053",
    transform: "translate(12.13 -20.776)",
    style: {
      fill: "#0d90db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 205",
    d: "m39.894 152.625-1.15-.045q0-1.294.007-2.588c.305 0 .611 0 .917-.01a1.362 1.362 0 0 0 .236-.047l1.192.009q0 1.314-.007 2.629c-.146 0-.292 0-.437.006-.252.012-.5.03-.757.046",
    transform: "translate(-23.945 -129.079)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 206",
    d: "m56.612 114.265-1.192-.009-.013-2.6 1.2-.006 1.165.006q0 1.3.006 2.594z",
    transform: "translate(-39.462 -93.4)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 207",
    d: "m55.4 266.589 1.2-.009 1.173.01q0 1.3-.007 2.592a.046.046 0 0 0-.028.04l-1.137.016c-.32 0-.641 0-.961-.009a1.4 1.4 0 0 1-.238-.046v-2.594",
    transform: "translate(-39.457 -237.798)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 208",
    d: "M55.4 188.811c.252-.016.5-.034.757-.046.145-.007.291 0 .437-.006.178 0 .356 0 .534.008.215.011.429.033.644.049q0 1.3-.009 2.592l-1.168.007-1.2-.008v-2.6",
    transform: "translate(-39.455 -165.265)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 209",
    d: "M124.323 305.71a.1.1 0 0 1-.01-.044.1.1 0 0 1 .047.005l-.037.039",
    transform: "translate(-103.627 -274.227)",
    style: {
      fill: "#f4fbff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 210",
    d: "m72.811 230.385 1.173.01.051-.01c.067-.011.134-.028.2-.036-.067.008-.134.025-.2.036h2.32a.119.119 0 0 0-.011-.044l.014-1.427v-1.162h-2.379l-1.168.007v2.632",
    transform: "translate(-55.666 -201.603)",
    style: {
      fill: "#ffc433"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 211",
    d: "m77.477 152.579-1.128-.015v-2.588h-2.126a1.079 1.079 0 0 1-.2-.036l-.046-.012-1.169.01q0 1.314-.007 2.629c.178 0 .356 0 .534.008.215.011.429.032.644.049q0 1.3-.009 2.592h2.379c.126.008.189-.026.216-.173a4.056 4.056 0 0 1 .222-.8c.216-.529.461-1.047.694-1.57l-.007-.1",
    transform: "translate(-55.663 -129.07)",
    style: {
      fill: "#ffc433"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 212",
    d: "m140.716 189.077-.007-.1.007.1",
    transform: "translate(-118.895 -165.469)",
    style: {
      fill: "#ffe07d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 213",
    d: "m77.576 271.872-1.129-.013-.021.005h-.021a.078.078 0 0 1 .008-.044h-.021l.017-2.546a.1.1 0 0 1-.01-.044.1.1 0 0 1 .047.005h.628l-.564-2.2-.109-.464h-2.32l-.051.01q0 1.3-.007 2.592a.046.046 0 0 0-.028.04l2.4.007v.008-.008l-2.4-.007-1.137.016v2.634l1.167.006v2.593h3.553q0-1.3-.005-2.591m-3.495 0 .066-.014-.066.014",
    transform: "translate(-55.714 -237.79)",
    style: {
      fill: "#e64d3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 214",
    d: "M76.369 39.179h-.023a.071.071 0 0 1 .008-.048h-.019l.015-2.545-.01-.049.051.007c.288 0 .576 0 .863-.011a1.621 1.621 0 0 0 .264-.051q0-1.3.006-2.591h-3.552v2.594a1.752 1.752 0 0 1-.264.049c-.3.01-.6.012-.906.016q0 1.312.006 2.625l1.165.006h.053c.066-.012.133-.032.2-.041-.067.009-.133.029-.2.041h-.053q0 1.3.006 2.594l.046.012 2.237-.01c.028 0 .056.028.084.044.177 0 .355.006.531 0 .214-.011.428-.034.642-.052v-2.588l-1.128-.011zm-.029-2.642z",
    transform: "translate(-55.657 -20.92)",
    style: {
      fill: "#0d90db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 215",
    d: "M124.345 111a.071.071 0 0 1 .008-.048l.037.045-.022.006z",
    transform: "translate(-103.655 -92.745)",
    style: {
      fill: "#d3eefa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 216",
    d: "m90.566 149.975 2.237-.01c.028 0 .056.028.084.044h-2.126a1.076 1.076 0 0 1-.2-.036",
    transform: "translate(-72.202 -129.107)",
    style: {
      fill: "#ffc433"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnGameType);
export default __webpack_public_path__ + "static/media/icn_game_type.b4f158579d593898ae30571fc52704d3.svg";
export { ForwardRef as ReactComponent };